import { render, staticRenderFns } from "./OnlimChatbot.vue?vue&type=template&id=e6ad2ee4"
import script from "./OnlimChatbot.vue?vue&type=script&lang=js"
export * from "./OnlimChatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports